import { type FC, useEffect } from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { useEventMessageUpdatedNew } from 'widgets/ContactsDetails/ui/ContactsConversationOpen/events/EventMessageUpdatedNew'
import { type ContactsConversationOpenStore } from 'widgets/ContactsDetails/ui/ContactsConversationOpen'
import { useEventMessageReceivedNew } from 'widgets/ContactsDetails/ui/ContactsConversationOpen/events/EventMessageReceivedNew'
import styles from 'widgets/ContactsDetails/ui/ContactsConversationOpen/ui/styles.module.scss'
import { ConversationNew } from 'widgets/ConversationNew'
import {
  ConversationContent,
  ConversationMessageField,
  ConversationMessagesContext,
  TypingContent,
} from 'widgets/ConversationMessages'
import {
  ContactsConversationOpenContext,
  useContactsConversationOpenContext,
} from '../context/contactsConversationOpenContext'

const ContactsConversationOpenContent = observer(() => {
  const store = useContactsConversationOpenContext()
  const conversationMessagesStore = store.conversationMessagesStore

  useEventMessageUpdatedNew(store)
  useEventMessageReceivedNew(store)

  useEffect(() => {
    if (!store.loading) {
      store.init()
    }
  }, [store.loading])

  useEffect(() => {
    conversationMessagesStore.setVariant('open_conversation')
    return store.reset
  }, [])

  if (store.loading) {
    return (
      <div className={classnames(styles.wrap, styles.wrap__loading)}>
        <SpinnerLoader ariaLabel={'ContactsConversationOpen'} />
      </div>
    )
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.header}>
        <ConversationNew store={store.conversationNewSearchStore} />
      </div>
      <div className={styles.messages}>
        <ConversationMessagesContext.Provider value={store.conversationMessagesStore}>
          <ConversationContent virtualized />
          <TypingContent />
          <ConversationMessageField inboxId={store.inbox?.id} />
        </ConversationMessagesContext.Provider>
      </div>
    </div>
  )
})

type IContactsConversationOpenProps = {
  store: ContactsConversationOpenStore
}

export const ContactsConversationOpen: FC<IContactsConversationOpenProps> = ({ store }) => {
  return (
    <ContactsConversationOpenContext.Provider value={store}>
      <ContactsConversationOpenContent />
    </ContactsConversationOpenContext.Provider>
  )
}
